import { useSelector } from "react-redux";
import c from "../header.module.css";
import { useEffect, useState } from "react";
import sendRequest from "../../../service";
import { useNavigate } from "react-router-dom";

export default function CategoryField({ mediaID, mediaName }) {
  const navigate = useNavigate();
  const categories = useSelector((state) => state.config.categories);

  function handleNavigate(item) {
    navigate("/category/" + item.id, { state: { category: item, mediaID, mediaName } });
  }

  return (
    <div className={c.categoryField}>
      {categories &&
        categories.map((item) => {
          return (
            <div
              className={c.categoryButton}
              onClick={() => handleNavigate(item)}
            >
              {item.name}
            </div>
          );
        })}
    </div>
  );
}
